import staticRoutes from "../../router/router";
import { getRoleMenuTree } from '@/api/system/menu.api'
import { buildDynamicRoutes, createEmptyDynamicRouteState } from '@/router/dynamicRoutes'

let menuRequest = null

function readJsonStorage(key, defaultValue) {
  try {
    const text = localStorage.getItem(key)
    return text ? JSON.parse(text) : defaultValue
  } catch (error) {
    return defaultValue
  }
}

function getCurrentRoleId() {
  const roleInfo = readJsonStorage('roleInfo', [])
  if (Array.isArray(roleInfo)) {
    const role = roleInfo.find(item => item && item.roleId !== undefined && item.roleId !== null && item.roleId !== '')
    return role ? role.roleId : undefined
  }
  return roleInfo && roleInfo.roleId
}

export default {
  state: {
    access: localStorage.getItem('access') ? localStorage.getItem('access') : '',// 登录成功以后，当前用户拥有的权限的数据
    menuTree: [],
    dynamicRoutes: [],
    routeAdded: false,
    menuAccess: createEmptyDynamicRouteState(false).access,
    menuLoading: false,
    menuList: []// 右侧的显示的菜单栏的数据
  },
  getters: {
    menuList(state) {
      return state.menuList
    },
    dynamicRoutes(state) {
      return state.dynamicRoutes
    },
    menuAccess(state) {
      return state.menuAccess
    },
    menuLoaded(state) {
      return state.menuAccess && state.menuAccess.loaded
    },
    buttonPerms(state) {
      return state.menuAccess && state.menuAccess.buttonPerms ? state.menuAccess.buttonPerms : []
    }
  },
  mutations: {
    setMenuLoading(state, loading) {
      state.menuLoading = loading
    },
    setUserMenus(state, menuTree) {
      state.menuTree = Array.isArray(menuTree) ? menuTree : []
      const routeState = buildDynamicRoutes(staticRoutes, state.menuTree)
      state.dynamicRoutes = routeState.dynamicRoutes
      state.menuList = routeState.menuList
      state.menuAccess = routeState.access
      state.routeAdded = false
    },
    setDynamicRoutesAdded(state, added) {
      state.routeAdded = added
    },
    clearUserMenus(state) {
      const emptyState = createEmptyDynamicRouteState(false)
      state.menuTree = []
      state.dynamicRoutes = emptyState.dynamicRoutes
      state.menuList = emptyState.menuList
      state.menuAccess = emptyState.access
      state.routeAdded = false
    }
  },
  actions: {
    loadUserMenus({ state, commit }, force) {
      if (state.menuLoading) {
        return menuRequest || Promise.resolve(state.menuAccess)
      }
      if (state.menuAccess && state.menuAccess.loaded && !force) {
        return Promise.resolve(state.menuAccess)
      }
      const roleId = getCurrentRoleId()
      if (roleId === undefined || roleId === null || roleId === '') {
        commit('setUserMenus', [])
        return Promise.reject(new Error('未获取到当前账号角色ID'))
      }
      commit('setMenuLoading', true)
      menuRequest = getRoleMenuTree({
        isFilter: '',
        roleId
      }).then(res => {
        const success = res && (res.success === true || Number(res.code) === 200 || Number(res.code) === 0)
        if (!success) {
          return Promise.reject(res)
        }
        const data = Array.isArray(res.data) ? res.data : []
        commit('setUserMenus', data)
        return state.menuAccess
      }).catch(error => {
        commit('setUserMenus', [])
        return Promise.reject(error)
      }).finally(() => {
        commit('setMenuLoading', false)
        menuRequest = null
      })
      return menuRequest
    },
    clearUserMenus({ commit }) {
      commit('clearUserMenus')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js